import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { checkPageView, PageViewConsumer, propTypesOfPageViewContext } from './PageView';

const propTypesOfPageStatistic = {
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
};

class PageStatisticInternal extends PureComponent {
  static propTypes = {
    ...propTypesOfPageViewContext,
    ...propTypesOfPageStatistic,
  };

  componentDidMount() {
    this.track();
  }

  componentDidUpdate() {
    this.track();
  }

  track() {
    const { pageView } = this.props;
    checkPageView(pageView);
    const { field, value } = this.props;
    if (value !== undefined) {
      pageView.addPageStatistic(field, value);
    }
  }

  render = () => null;
}

const PageStatistic = (props) => (
  <PageViewConsumer>
    {context => <PageStatisticInternal {...context} {...props} />}
  </PageViewConsumer>
);

PageStatistic.propTypes = propTypesOfPageStatistic;

export default PageStatistic;
